import {
	Box,
	List,
	ListItem,
	ListItemButton,
	ListItemText,
	ListItemIcon,
	Typography,
} from '@mui/material';
import { DataCategory } from './DataHubSidebar';

// 1. Category type definition
export interface DataSummary extends DataCategory {
	count: number;
}

// 2. Props definition
export interface DataHubSummaryProps {
	categories: DataSummary[];
}

export default function DataHubSummary({ categories }: DataHubSummaryProps) {
	return (
		<Box sx={{ width: '100%', maxWidth: 360 }}>
			<List component="nav" aria-label="main mailbox folders">
				{categories.map((category) => {
					return (
						<ListItem
							key={category.id}
							disablePadding
						>
							<ListItemButton key={category.id} sx={{
								// No hover effect, no selection border, no background change
								cursor: 'text',
								'&:hover': {
									bgcolor: 'transparent', // Prevent background change on hover
								},
							}}>
								<ListItemIcon>
									{category.icon}
								</ListItemIcon>
								<ListItemText
									primary={
										<Typography>
											{category.label}
										</Typography>
									}
								/>
								<Box sx={{ flex: 1 }} /> {/* Spacer */}
								{category.count && (
									<Typography component="span" variant="body2" color="text.secondary" sx={{ fontWeight: 'bold' }}>
										{category.count}
									</Typography>
								)}
							</ListItemButton>
						</ListItem>
					)
				}
				)}
			</List>
		</Box>
	);
}